// Semnalele de eroare, într-un singur loc.
//
// Nu e un context React, ci un mic emițător de modul, DELIBERAT: clientul de
// API (`api.ts`) nu e o componentă și nu poate folosi un hook, iar exact acolo
// trebuie prinse erorile de server — altfel fiecare ecran ar trebui să-și
// amintească singur să afișeze ceva, și unul o va uita.

/** `lucru` = ceva în curs: toastul poartă o bulină care pulsează şi stă
 *  cât ţine treaba, nu cele 7 secunde. */
export type Fel = "eroare" | "info" | "lucru";
/** One button beside the message, e.g. «Vezi» opening what the toast announces. */
export type Actiune = { eticheta: string; laClic: () => void };
export type Toast = { id: number; mesaj: string; fel: Fel; actiune?: Actiune };

let urmatorId = 1;
let toasturi: Toast[] = [];
const abonati = new Set<(t: Toast[]) => void>();

function emite() {
  const copie = [...toasturi];
  abonati.forEach((f) => f(copie));
}

/** Arată un toast și întoarce id-ul lui, ca cine l-a pus să-l poată stinge
 *  înainte de vreme (un «se pregătește…» stins când s-a terminat).
 *  `durataMs` null = nu se stinge singur: pentru un «se salvează…» care ține
 *  cât ține cererea, nu 7 secunde — cine l-a pus îl stinge. */
export function arata(mesaj: string, fel: Fel = "eroare", durataMs?: number | null,
                      actiune?: Actiune): number {
  // Același mesaj de două ori la rând (două cereri care pică împreună) e un
  // singur semnal pentru om, nu două.
  const deja = toasturi.find((t) => t.mesaj === mesaj);
  if (deja) return deja.id;
  const toast: Toast = { id: urmatorId++, mesaj, fel, ...(actiune ? { actiune } : {}) };
  toasturi = [...toasturi, toast];
  emite();
  // A toast with a button stays twice as long: it asks for a click.
  const durata = durataMs === undefined ? (actiune ? 15000 : 7000) : durataMs;
  if (durata != null) setTimeout(() => inchide(toast.id), durata);
  return toast.id;
}

export function inchide(id: number) {
  toasturi = toasturi.filter((t) => t.id !== id);
  emite();
}

export function aboneaza(f: (t: Toast[]) => void) {
  abonati.add(f);
  f([...toasturi]);
  return () => { abonati.delete(f); };
}
